import { render, staticRenderFns } from "./ShortcutsWebpart.vue?vue&type=template&id=39bec608"
import script from "./ShortcutsWebpart.ts?vue&type=script&lang=ts&external"
export * from "./ShortcutsWebpart.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports